export default __webpack_public_path__ + "static/jondan-de47a1725f026284f1a6c69c143a6857.jpg";